// @flow
import fetchFromApiServer from '../../../service/index';


export function getPaymentURLToRedirect(obj){
    var url = 'WMSDetail/SetPaymentTransaction';
    return {
      type:'GET_PAY_URL_TO_REDIRECT',
      payload:fetchFromApiServer("POST", url, obj)
    }
  }

  export function storeRetailPrice(price){
    return {
      type:'RETAIL_PRICE',
      payload:price,
    }
  }
  
  export function getPaymentOption(obj){
    var url = 'WMSDetail/GetPaymentOptions';
    return {
      type:'GET_PAYMENT_OPTION',
      payload:fetchFromApiServer("POST", url, obj)
    }
  }

  export function getAtomPaymentURL(obj){
    var url = 'WMSPayment/InitialPayment';
    return {
      type:'GET_ATOM_PAYMENT_URL',
      payload:fetchFromApiServer("POST", url, obj)
    }
  }
